import React, { FC } from 'react';
import { HttpService } from '@core/services';
import { ProjectHttpService } from '@core/services/http';
import { FileType } from '@models/types';
import { Import } from '@shared/modules/import';

export const ProjectDatesImport: FC = () => (
  <Import
    template="PACE-Dates-Template"
    sendFile={(file: FileType): Promise<void> =>
      HttpService.getHttpRequests(ProjectHttpService).importProjectPACEDates(
        file,
      )
    }
  />
);
